import React from 'react'
import PropTypes from 'prop-types'

const SelectedSex = ({ selectedSex }) => {
  return selectedSex === 'gutt' ? <span>han</span> : <span>hun</span>
}

SelectedSex.propTypes = {
  selectedSex: PropTypes.string
}

export default SelectedSex



// WEBPACK FOOTER //
// ./src/components/SelectedSex/SelectedSex.js